import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ onEnter, ...rest }) => {
  const allowed = typeof onEnter === "function" ? onEnter() : true;

  if (!allowed) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: rest.location?.pathname || rest.path || "/" },
        }}
      />
    );
  }

  return <Route {...rest} />;
};

export default PrivateRoute;